import axios, { AxiosRequestConfig } from "axios";
import { addSagAuthInterceptor } from "../utils/interceptors/sag-auth-interceptor";
import { useSagOptions } from "@sazka/utils/http-clients/use-sag-options";
import { addLoggerInterceptor } from "../utils/interceptors/logger-interceptor";
import { addErrorInterceptor } from "../utils/interceptors/error-interceptor";
import { addLogoutInterceptor } from "../utils/interceptors/logout-interceptor";
import { addPlayerIdInterceptor } from "../utils/interceptors/player-id-interceptor";

const { getSagApiUrl } = useSagOptions();

/**
 * Axios basic configuration
 * Some general configuration can be added like timeout, headers, params etc. More details can be found on https://github.com/axios/axios
 * */
const config: AxiosRequestConfig = {
    baseURL: getSagApiUrl("ls-public-api", "wheel-of-fortune"), // FUAT
    //baseURL: "https://loyalty.dev.sazka.cz/api/wheel-of-fortune", // DEV
};

/**
 * Creating the instance of Axios
 * It is because, in large scale application we may need to consume APIs from more than single server,
 * So, may need to create multiple http client with different config
 * Only this client will be used rather than axios in the application
 **/
const lsAdminPublicClient = axios.create(config);

addSagAuthInterceptor(lsAdminPublicClient);
addLoggerInterceptor(lsAdminPublicClient);
addPlayerIdInterceptor(lsAdminPublicClient);
addLogoutInterceptor(lsAdminPublicClient);
addErrorInterceptor(lsAdminPublicClient);

export { lsAdminPublicClient };
